import { createContext, useContext } from "react";
import { BRAND, SECTION_COLORS } from "../theme";

/**
 * Acento de la sección activa. SectionLayout lo provee y ChartCard
 * (u otros hijos) lo consumen para teñir tags, botones y detalles
 * sin prop-drilling por cada tarjeta.
 */
export const SectionAccentContext = createContext({
  accent: BRAND.nodoBlue,
  dark: BRAND.nodoBlueDk,
  soft: SECTION_COLORS.economia.soft,
});

export const useSectionAccent = () => useContext(SectionAccentContext);
